module.exports = __webpack_public_path__ + "static/media/opening_14.6384cdd9.webp";